// extracted by mini-css-extract-plugin
module.exports = {"buttonToAnswerQuestion":"Ks","disabled":"Ls","seeAllAnswers":"Ms"};